export const INITIATE = '[LOGS] INITIATE';
export const GET_LOGS = '[LOGS] GET LOGS';
export const CHANGE_START_DATE = '[LOGS] CHANGE START DATE';
export const CHANGE_END_DATE = '[LOGS] CHANGE END DATE';
export const CHANGE_FILTER = '[LOGS] CHANGE FILTER';
export const CHAGNE_SORT_BY = '[LOGS] CHAGNE SORT BY';
export const CHAGNE_SORT_BY_DATE = '[LOGS] CHAGNE SORT BY DATE';
export const CHANGE_ACTIVE_TS_PAGE = '[LOGS] CHANGE ACTIVE TS PAGE';
export const CHANGE_MAX_ROWS_COUNT = '[LOGS] CHANGE MAX ROWS COUNT';
